/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import * as Yup from "yup";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const pancardRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
const gstnoRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const cinnumberRegex =
  /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;
// const pfaccountnumberRegex = /[A-Z]{2}[A-Z]{3}[0-9]{7}[0-9]{3}[0-9]{7}/;
const ifsccodeRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// Helper function to get isVerifiedGST from cookies
const getIsVerifiedGST = () => cookies.get("isVerifiedGST") === true;

const validationSchema = {
  // vendor form

  validationSchemaForStepOne: {
    lineOfBusiness: Yup.string().required("Choose a Line Of Business"),
    currency: Yup.string().required("Choose a Currency"),
    supplierName: Yup.string().required("Enter a Supplier Name"),
    buildingNoName: Yup.string().optional("Enter a Building No/Name"),
    floor: Yup.string().optional("Enter a Floor"),
    street: Yup.string().required("Enter a Street"),
    // country: Yup.object().required("Choose a Country"),
    state: Yup.string().required("Choose a State"),
    city: Yup.string().required("Enter a City"),
    // pinCode: Yup.string()
    //   .required("Enter a PinCode")
    //   .matches(/^[0-9]+$/, "Must be only digits")
    //   .min(6, "Must be exactly 6 digits")
    //   .max(6, "Must be exactly 6 digits"),
    contactPerson: Yup.string().required("Enter a Contact Person"),
    contactNo: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Enter a Contact No"),
    email: Yup.string().email("E-mail is Invalid").required("Enter a E-mail"),
    industrialType: Yup.array(
      Yup.string().oneOf([
        "Dealer",
        "Manufacturer",
        "Service",
        "Sub-Contractor",
        "Trader",
        "Others",
      ])
    )
      .min(1, "Choose atleast one")
      .required("Choose the Industrial Type"),

    gstNo: Yup.string()
      .matches(gstnoRegex, "Invalid Format")
      .required("Enter GST No")
      .test("isVerifiedGST", "GST must be verified", () => getIsVerifiedGST()),
  },

  validationSchemaForStepTwo: {
    pan: Yup.string()
      .required("Enter PAN No")
      .matches(pancardRegex, "Invalid Format"),

    cinNumber: Yup.string()
      .required("Enter CIN No")
      .matches(cinnumberRegex, "Invalid Format"),
    sezNonsez: Yup.string().required("Choose a SEZ Type"),
    rcmApplicable: Yup.string().required("Enter rcm applicable"),
    paymentTerms: Yup.string().required("Enter a payment term"),
    msmedAct: Yup.string().oneOf(["Yes", "No"]).required("Required"),
    tdsLowerDeduction: Yup.string().oneOf(["Yes", "No"]).required("Required"),
    categoryOfSupply: Yup.array(
      Yup.string().oneOf(["Material", "Services", "Man Power", "Others"])
    )
      .min(1, "Choose atleast one")
      .required("Choose Category Of Supply"),
    pfAccountNumber: Yup.string().optional(),

    esiAccountNumber: Yup.string().optional(),
  },

  validationSchemaForStepThree: {
    beneficiaryBank: Yup.string().required("Enter Beneficiary Bank "),
    bankAddress: Yup.string().required("Enter Beneficiary Address"),
    accountNumber: Yup.number().required("Enter Account Number"),
    accountType: Yup.string().required("Choose Account Type"),
    accountName: Yup.string().required("Enter Account Name"),
    ifscCode: Yup.string()
      .matches(ifsccodeRegex, "Invalid Format")
      .required("Enter IFSC Code"),
    swiftCodeIban: Yup.string(),
    swiftCodeOfIntermediaryRoutingBank: Yup.string(),
    intermediaryRoutingBank: Yup.string(),
  },

  validationSchemaForStepFour: {
    incorporationCertificate: Yup.mixed()
      .required("Upload Incorporation Certificate")
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        return value && value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        return value && value.type === "application/pdf";
      }),
    cancelledCheque: Yup.mixed()
      .required("Upload Cancelled Cheque")
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        return value && value.size <= 1000000;
      })
      .test("type", "Upload PDF Or Image Only", (value) => {
        return (
          value &&
          (value.type === "application/pdf" ||
            value.type === "image/png" ||
            value.type === "image/jpg" ||
            value.type === "image/jpeg")
        );
      }),

    panCard: Yup.mixed()
      .required("Upload PAN Card")
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        return value && value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        return value && value.type === "application/pdf";
      }),
    gstRegistrationCertificate: Yup.mixed()
      .required("Upload GST Registration Certificate")
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        return value && value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        return value && value.type === "application/pdf";
      }),
    validLut: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    contract: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    other: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    sezApproval: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    pfCertificate: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    esiCertificate: Yup.mixed()
      .optional()
      .test("fileSize", "Maximum File Size 900 KB", (value) => {
        if (!value) return true;
        return value.size <= 1000000;
      })
      .test("type", "Upload PDF Only", (value) => {
        if (!value) return true;
        return value.type === "application/pdf";
      }),

    tdsLowerDeductionCertificate: Yup.mixed().when("tdsLowerDeduction", {
      is: "Yes",
      then: () =>
        Yup.mixed()
          .required("Upload tds LowerDeduction Certificate")
          .test("fileSize", "Maximum File Size 900 KB", (value) => {
            return value && value.size <= 1000000;
          })
          .test("type", "Upload PDF Only", (value) => {
            return value && value.type === "application/pdf";
          }),
      otherwise: () => Yup.mixed().optional(),
    }),
    msmeCertificate: Yup.mixed().when("msmedAct", {
      is: "Yes",
      then: () =>
        Yup.mixed()
          .required("Upload msme Certificate")
          .test("fileSize", "Maximum File Size 900 KB", (value) => {
            return value && value.size <= 1000000;
          })
          .test("type", "Upload PDF Only", (value) => {
            return value && value.type === "application/pdf";
          }),
      otherwise: () => Yup.mixed().optional(),
    }),
  },
};

export default validationSchema;
